import {
    SWITCH_GROWTH_ANALYSIS_PERIOD,
    SWITCH_PERIOD,
    SWITCH_PM_PERIOD,
} from '../../actionTypes/shared/apiActionTypes';

export const switchPeriod = (selectedPeriod, studentId) => ({
    type: SWITCH_PERIOD,
    selectedPeriod,
    studentId,
});

export const switchPmPeriod = (selectedPeriod, subtabTitle) => ({
    type: SWITCH_PM_PERIOD,
    selectedPeriod,
    subtabTitle,
});

export const switchGrowthAnalysisPeriod = (selectedGrowthAnalysisPeriod, subtabTitle) => ({
    type: SWITCH_GROWTH_ANALYSIS_PERIOD,
    selectedGrowthAnalysisPeriod,
    subtabTitle,
});
